import { Box } from "@mui/material"
import CommonCheckAttendance from "./CommonCheckAttendance"
import CommonSeeMemory from "./CommonSeeMemory"
import CustomDivider from "../../shared/utils/CustomDivider"



const CommonMomentAndAttendance = () => {

    return (
        <Box>
            <CommonSeeMemory />
            <CustomDivider />
            <CommonCheckAttendance />
            <CustomDivider />
        </Box>
    )
}

export default CommonMomentAndAttendance